import { CustomElement } from 'shared/components/element.js';
import { api } from '@converse/headless';
import tplCreateNewsButton from './templates/create-news-button.js';

import './modals/create-news.js';

/**
 * @class
 * @namespace _converse.CreateNewsButton
 * @memberOf _converse
 */
export default class CreateNewsButton extends CustomElement {
    render() {
        return tplCreateNewsButton();
    }

    connectedCallback() {
        super.connectedCallback();
        this.classList.add('create-news-button');
    }
}

api.elements.define('converse-create-news-button', CreateNewsButton);
